/**
 * Adds an event handler to all add to cart buttons that allows us to async add items to the cart
 */
const addToCartBtnInit = (): void => {
  const addToCartBtns = document.querySelectorAll('[data-add-to-cart]');

  addToCartBtns.forEach((btn: HTMLElement) => {
    btn.addEventListener('click', e => {
      e.preventDefault();

      const el = <HTMLInputElement>e.target;
      el.classList.add('loading');
      const selector = el.dataset.atcQuantityInput;
      let productId = parseInt(el.dataset.atcProductId);

      const upsellItem = el.closest('[data-upsell-item]');
      if (upsellItem) {
        const upsellProductId = upsellItem.querySelector('[data-atc-product-id]').getAttribute('data-atc-product-id');
        if (upsellProductId) {
          productId = parseInt(upsellProductId);
        }
      } else {
        productId = parseInt(el.dataset.atcProductId);
        
        // handle ReCharge product ids
        const rcSelect = <HTMLSelectElement>document.querySelector('#rc_duplicate_selector');
        const variantDetails = document.querySelector('variant-details');
        const selectedVariantImage = document.querySelector('.variant-image.selected-variant-image');

        if (variantDetails && selectedVariantImage) {
          productId = parseInt(selectedVariantImage.getAttribute('data-variant-id'));
        } else if (rcSelect && rcSelect.name === 'id') {
          productId = parseInt(rcSelect.value);
        }
      }

     // Collect properties (existing behavior)
const propertiesToGet = [
  'subscription_id',
  'shipping_interval_unit_type',
  'shipping_interval_frequency',
  'charge_interval_frequency',
  'charge_interval_unit_type',
  '_from-upsell-modal'
] as const;

const properties: Record<string, string> = {};
propertiesToGet.forEach((property) => {
  const key = `properties[${property}]`;
  const propEl = document.querySelector(`[name="${key}"]`) as HTMLInputElement | null;
  if (propEl && propEl.value !== '') properties[property] = propEl.value;
});

// Quantity
const input = document.querySelector(selector!) as HTMLInputElement | null;
const quantity = parseInt(input?.value || '1', 10);

// Find selling plan ID within the closest product form or upsell, else fall back to document
const scope: ParentNode | Document =
  (el.closest('form[action*="/cart/add"]') as HTMLFormElement | null) ||
  upsellItem ||
  document;

const sellingPlanInput =
  (scope.querySelector('input[name="selling_plan"]:checked') as HTMLInputElement | null) ||
  (scope.querySelector('select[name="selling_plan"]') as HTMLSelectElement | null) ||
  (scope.querySelector('input[name="selling_plan"]') as HTMLInputElement | null);

const selling_plan: string | undefined =
  sellingPlanInput && sellingPlanInput.value ? sellingPlanInput.value : undefined;

// Build line item; only include selling_plan if present
const lineItem: {
  id: number;
  quantity: number;
  properties?: Record<string, string>;
  selling_plan?: string;
} = { id: productId, quantity, properties };

if (selling_plan) lineItem.selling_plan = selling_plan;

// If a selling plan is selected, post directly to /cart/add.js so Shopify receives it.
// Otherwise, use your existing blubolt path.
const addWithAjax = async () => {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(lineItem)
  });
  if (!res.ok) throw new Error(`Add to cart failed (${res.status})`);
  return res.json();
};

const addWithBlubolt = () =>
  new Promise((resolve) => {
    window['blubolt'].cart.addToCart([lineItem], true, (cart: unknown) => resolve(cart));
  });

(async () => {
  try {
    // Perform the add (either direct AJAX for subs or blubolt for one-time)
    await (selling_plan ? addWithAjax() : addWithBlubolt());

    // ✅ Always get the full cart after adding
    const fullCart = await fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    }).then(r => {
      if (!r.ok) throw new Error(`Fetch /cart.js failed (${r.status})`);
      return r.json();
    });

    // UI success
    el.classList.remove('loading');
    el.classList.add('success');
    setTimeout(() => el.classList.remove('success'), 3000);

    // ✅ Dispatch the full cart (never the add.js line item)
    document.dispatchEvent(new CustomEvent('cart:added', { detail: { cart: fullCart } }));
  } catch (err) {
    el.classList.remove('loading');
    console.error('Add to cart failed:', err);
    // TODO: show an error toast/message if desired
  }
})();

    }, false);
    
    btn.removeAttribute('data-add-to-cart')
  })
}

export default addToCartBtnInit;
